export default __webpack_public_path__ + "static/media/BlackRectangle.490c7513.svg";